import React, {Component} from 'react';
const { connect } = require('react-redux');
const { Link } = require('react-router');
const moment = require('moment');
const Datetime = require('react-datetime');

import {Form} from 'form';

import GenderSelect from 'components/common/GenderSelect';
import CountrySelect from 'components/common/CountrySelect';
import RegionSelect from 'components/common/RegionSelect';

import {getRegions} from '../../backend-helpers/misc';

import {t} from 'l10n'
import {formatLocation, getGenderText, getAgeText} from 'utils/user'

import '../../sass/headers/headerMemberProfile.scss';
import '../../sass/headers/informationBlock.scss';
import '../../sass/react-datatime.scss';

import {setCurrentUser} from 'reducers/currentUser';

import {saveCurrentUser} from 'backend-helpers/member'

class HeaderMemberIndex extends Component {
    render() {
        let {edit} = this.props;

        return (
            <header className="header-my-profile">
                <div className="content">
                    {edit ?
                        <HeaderMemberProfileEdit {...this.props}/> :
                        <HeaderMemberProfileView {...this.props}/>
                    }
                </div>
            </header>
        )
    }
}

export default connect(
    state => ({currentUser: state.currentUser}),
    {
        setCurrentUser: setCurrentUser
    }
)(HeaderMemberIndex);



class HeaderMemberProfileView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showFullAbout: false
        }
    }

    toggleShowText() {
        this.setState({
            showFullAbout: !this.state.showFullAbout
        })
    }

    render() {
        let {currentUser, stats, toggleEdit} = this.props;

        let userAbout = [], userAboutFull = null;

        if (currentUser.about) {
            userAbout = currentUser.about
                .split("\n")
                .map(function(item) { return item.trim() })
                .filter(function(item) { return item });

            userAboutFull = null;

            if (userAbout.length > 3) {
                userAboutFull = userAbout;
                userAbout = userAboutFull.slice(0, 3);
            }
        }

        return (
            <div className="text-header-profile">
                <div>
                    <div className="img-profile">
                        <div className="top">
                            <div className="img">
                                <img src={currentUser.avatar_url} alt="" />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="text-profile">
                    <p className="name">
                        {currentUser.nick}
                        <span className="icon-edit-profile" onClick={()=>{toggleEdit()}}></span>
                    </p>
                    <div className="informations">
                        <p>
                            {getGenderText(currentUser)} <span className="dot"></span>
                            {getAgeText(currentUser)} <span className="dot"></span>
                            {formatLocation(currentUser, true)}
                        </p>
                    </div>
                    {!this.state.showFullAbout ?
                        <div className="description">
                            {userAbout.map((line, index) =>  <p key={index} dangerouslySetInnerHTML={{__html: line}}/>)}
                            {userAboutFull && <p><span className="show-all-text" onClick={()=>{this.toggleShowText()}}>{t('Show more')}</span></p>}
                        </div>
                        :
                        <div className="description">
                            {userAboutFull.map((line, index) =>  <p key={index} dangerouslySetInnerHTML={{__html: line}}/>)}
                        </div>
                    }

                    <div className="information-block">
                        <div className="item views">
                            <div className="icon"/>
                            <p>{stats.viewCount} {t('views')}</p>
                        </div>
                        <div className="item followers">
                            <div className="icon"/>
                            <p>{stats.followerCount} {t('followers')}</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


class HeaderMemberAvatar extends Component {


    constructor(props) {
        super(props);
        this.state = {
            mouseover: false
        }
        this.first_click = true;
    }

    onTouchStart (e) {
        if(!this.state.mouseover) {
            this.first_touch = true;
            this.setState({mouseover : true})
        }
    }

    onTouchEnd (e) {
        if(this.first_touch) {
            e.preventDefault();
            this.first_touch = false;
        }
    }

    onMouseover (e) {
        this.setState({mouseover : true})
    }

    onMouseout (e) {
        this.setState({mouseover : false})
    }

    render() {
        const {mouseover} = this.state;
        let {openChangeAvatarModal, currentUser} = this.props;

        return (
            <div className="top" onTouchStart={ this.onTouchStart.bind(this) } onTouchEnd={ this.onTouchEnd.bind(this) }  onMouseEnter={this.onMouseover.bind(this)} onMouseLeave={this.onMouseout.bind(this)}>
                { mouseover ?
                <div className="button">
                    <div className="change" onClick={() => { openChangeAvatarModal(); } }>{t('Change')}</div>
                </div>
                    : ''}
                <div className="img">
                    <img src={currentUser.avatar_url} alt="" />
                </div>
            </div>
        )
    }
}


class HeaderMemberProfileEdit extends Component {
    constructor(props) {
        super(props);

        this.state = {
            openCalendar: false,
            ageValue: '-',
            regions: null,
            gender: this.props.currentUser.gender
        };

        this.onSubmit = this.onSubmit.bind(this);
        this.changeGender = this.changeGender.bind(this);
    }

    changeAge(e) {
        let years = e.fromNow('y');
        this.setState({
            ageValue: years
        })
    }
    
    changeGender(e) {
        this.setState({gender: e.target.value})
    }

    showCalendar() {
        this.setState({
            openCalendar: true
        })
    }

    closeCalendar() {
        this.setState({
            openCalendar: false
        })
    }

    onCountrySelectChange(event) {
        let country = event.target.value;
        this.getRegions(country);
    }

    getRegions(country) {
        let that = this;

        getRegions(country).then(function(response) {
            that.setState({regions: response.data});
        }).catch(

        );
    }

    onSubmit(formData, setErrors) {
        let {toggleEdit, setCurrentUser} = this.props;

        saveCurrentUser(formData).then(function(response) {
            toggleEdit();
            setCurrentUser(response.user)
        }).catch(function(error) {
            setErrors(error.messages);
        });
    }

    componentDidMount() {
        let {currentUser} = this.props;
        this.getRegions(currentUser.country);
    }

    componentWillReceiveProps(nextProps) {
        let {currentUser} = nextProps;
        this.getRegions(currentUser.country);
    }

    componentDidUpdate() {
        if (this.state.editName) {
            this.refs.username.focus();
        }
    }

    render() {
        const { 
            nickChangeRequestSent,
            openChangeAvatarModal,
            openChangeNickModal,
            openChangePasswordModal,
            openChangeEmailModal,
            openChangePhoneModal,
            currentUser,
            toggleEdit
        } = this.props;

        const {showText, ageValue, openCalendar, gender} = this.state;

        // todo: Datetime locale prop

        return (
            <div className="text-header-profile">
                <div className="img-profile">
                    <HeaderMemberAvatar {...this.props}/>
                    <div className="change-button">
                        <div className="password" onClick={openChangePasswordModal}>{t('Change password')}</div>
                        <div className="email" onClick={openChangeEmailModal}>{t('Change email')}</div>
                        <div className="phone" onClick={openChangePhoneModal}>{t('Change phone')}</div>
                    </div>
                </div>

                <div className="text-profile">
                    <Form onSubmit={this.onSubmit}>
                        <input type="hidden" name="id" value={currentUser.id}/>
                        <input type="hidden" name="nick" value={currentUser.nick}/>

                        <p className="name editName">
                            {currentUser.nick}
                            {!nickChangeRequestSent ? <span className="icon" onClick={openChangeNickModal}/> : <span className="nick-change-request-sent">{t('You have requested a change of nick. We will process it as soon as possible.')}</span>}
                        </p>
                        <div className="informations flex">
                            <div>
                                <label>{t('Gender:')}</label>
                                <GenderSelect name="gender" onChange={this.changeGender} value={gender}/>
                            </div>
                            <div className="age-content"
                                 tabIndex="0" onBlur={()=>{this.closeCalendar()}}
                                 onClick={()=>this.showCalendar()}
                            >
                                <label>{t('Age:')}</label>
                                <input type="text" name="age" defaultValue={currentUser.age}/>
                                {/*
                                <input type="text" value={ageValue} disabled className={(openCalendar) ? "active" : ""} />
                                <div className="icon-calendar"></div>
                                <div className={(openCalendar) ? "content-datatime" : "content-datatime hide"}>
                                    <Datetime
                                        input={false}
                                        open={true}
                                        locale="en-US"
                                        timeFormat={false}
                                        onChange={(e)=>this.changeAge(e)}
                                    />
                                </div>
                                */}
                            </div>
                            <div>
                                <label>{t('Country:')}</label>
                                <CountrySelect name="country" onChange={(event) => this.onCountrySelectChange(event)} defaultValue={currentUser.country}/>
                            </div>
                            <div className="region-content">
                                <label>{t('Region:')}</label>
                                <RegionSelect name="region" defaultValue={currentUser.region} regions={this.state.regions}/>
                            </div>
                        </div>
                        <div className="description edit">
                            <label>{t('About:')}</label>
                            <textarea name="about" defaultValue={currentUser.about}></textarea>
                        </div>
                        <div className="buttons">
                            <button type="submit" className="save">{t('Save')}</button>
                            <button type="button" className="cancel" onClick={()=>toggleEdit()}>{t('Reset')}</button>
                        </div>
                    </Form>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/member/HeaderMemberIndex.js